<template>
  <div class="balance-apply">
    <!--标题-->
    <div class="primary-title">
      <div class="region-title">订单详情</div>
    </div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="100px">
        <el-form-item label="订单号:">{{ basicInfo.orderNo }}</el-form-item>
        <el-form-item label="收货人:">{{ basicInfo.shouhuoren }}</el-form-item>
        <el-form-item label="收货人手机号:">{{ basicInfo.phone }}</el-form-item>
        <el-form-item label="收货地址:">{{ basicInfo.address }}</el-form-item>
        <el-form-item label="创建日期:">{{ basicInfo.dateSubmitted }}</el-form-item>
        <el-form-item label="订单状态:">
          <span class="color-blue" @click="$refs.dialogRef.show('status', '订单状态', gridData)">{{ basicInfo.orderStatus }}</span>
        </el-form-item>
      </el-form>
    </div>
    <div class="third-title"><span>平台信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="platformList" label-width="100px">
        <el-form-item label="平台号:">{{ platformList.storeCode }}</el-form-item>
        <el-form-item label="平台名称:">{{ platformList.storeName }}</el-form-item>
        <el-form-item label="手机号:">{{ platformList.storePhone }}</el-form-item>
        <el-form-item label="地址:">{{ platformList.address }}</el-form-item>
      </el-form>
    </div>
    <div class="third-title"><span>任务信息</span></div>
    <div class="data-list">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="taskNum" label="任务号" min-width="100"></el-table-column>
        <el-table-column prop="skuName" label="SKU组名称" min-width="100"></el-table-column>
        <el-table-column prop="proName" label="产品名称" min-width="100"></el-table-column>
        <el-table-column prop="platformPrice" label="平台单价" min-width="100"></el-table-column>
        <el-table-column prop="count" label="数量" min-width="100"></el-table-column>
        <el-table-column prop="platPAll" label="平台总价" min-width="100"></el-table-column>
        <el-table-column label="客户名称" min-width="100">
          <template v-slot="scope">
            <span class="color-blue" @click="$refs.dialogRef.show('primary', '客户名称', '客户名称: ' + scope.row.remark)">{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
        <el-table-column label="任务状态" min-width="100">
          <template v-slot="scope">
            <span class="color-blue" @click="$refs.dialogRef.show('status', '任务状态', gridData)">{{ scope.row.taskStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="kuaidi" label="快递追踪" min-width="100">
        </el-table-column>
      </el-table>
    </div>
    <div class="remaining-sum" v-if="type === 0">
      <div style="margin-right: 50px;">
        <h3>平台价格总计：</h3>{{ balance }}
      </div>
      <div style="margin-right: 50px;">
        <h3>申请价格总计：</h3>{{ balance }}
      </div>
      <div style="margin-right: 20px;">
        <el-button type="" round @click="$refs.dialogRef.show('balanceapply', '确定提示', '是否审核拒绝<br/>是否确定审核拒绝？', '', '', 'balanceCheckTrue')">审核拒绝</el-button>
      </div>
      <div>
        <el-button type="primary" round @click="$refs.dialogRef.show('balanceapply', '确定提示', '是否审核通过<br/>是否确定审核通过？', '', '', 'balanceCheckTrue')"> 审核通过 </el-button>
      </div>
    </div>
    <div class="remaining-sum" v-if="type === 1">
      <div style="margin-right: 50px;">
        <h3>平台价格总计：</h3>{{ balance }}
      </div>
      <div style="margin-right: 50px;">
        <h3>申请价格总计：</h3>{{ balance }}
      </div>
      <el-button round type="primary" @click="returnPage">返回</el-button>
    </div>
    <div class="remaining-sum" v-if="type === 2">
      <div style="margin-right: 50px;">
        <h3>总计：</h3>{{ balance }}
      </div>
      <el-button round type="primary" @click="returnPage">返回</el-button>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
  </div>
</template>
 <script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index.vue'
export default {
  name: 'balance-apply',
  components: { CombinedDialog },
  data () {
    return {
      basicInfo: {
        orderNum: '',
        shouhuoren: '',
        phone: '',
        address: '',
        createDate: '',
        orderStatus: ''
      },
      platformList: {
        platformNum: '',
        platformName: '',
        phone: '',
        address: ''
      },
      tableData: [],
      balance: 0, // 余额支付
      gridData: []
    }
  },
  created () {
    this.type = parseInt(this.$route.query.id)
  },
  methods: {
    returnPage () {
      if (window.history.length <= 1) {
        this.$router.push({ path: '/home' })
        return false
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
 <style scoped lang="less">
 @import "index.less";
 @deep: ~">>>";
 </style>
